<template>
  <div class="container-fluid p-0">
    <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm py-0">
      <a class="navbar-brand order-0" href="#">
        <img src="@/assets/nav-logo.png" class="logo" />
      </a>
      <button
        class="navbar-toggler ml-auto border-0 order-1"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <ul class="mb-0 pl-3 order-2 order-lg-3">
        <li class="nav-item" id="signout">
          <div class="dropdown">
            <button
              class="btn dropdown-toggle p-0"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img class="user" src="@/assets/user.jpg" />
            </button>
            <div
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="dropdownMenuButton"
            >
              <div class="dropdown-item-text small text-muted">
                {{ user && user.email }}
              </div>
              <div class="dropdown-divider"></div>
              <button
                class="dropdown-item small"
                @click="showPasswordModal = true"
              >
                <font-awesome-icon :icon="['fas', 'key']" class="mr-2" />
                Change Password
              </button>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="#" @click.prevent="logout()">
                <small>Sign Out</small>
              </a>
            </div>
          </div>
        </li>
      </ul>
      <div
        class="collapse navbar-collapse order-3 order-lg-2"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav mr-auto">
          <template
            v-for="route in routes.filter(
              (route) =>
                !route.roleRestricted ||
                (user && !route.roleRestricted.includes(user.role.name))
            )"
          >
            <li
              v-if="route.name != $route.name && route.type == 'dropdown'"
              :key="route.name"
              class="
                nav-item
                dropdown
                justify-content-start justify-content-lg-center
              "
              :class="{ active: isActiveNav(route.name) }"
            >
              <a
                class="nav-link dropdown-toggle"
                href="#"
                :id="`navbar-${route.name}`"
                role="button"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <font-awesome-icon :icon="route.icon" />{{ route.label }}
              </a>
              <div class="dropdown-menu">
                <router-link
                  class="nav-link dropdown-item text-dark small"
                  :to="{
                    name: route.name,
                  }"
                  v-if="
                    !route.dropdownOptions || !route.dropdownOptions.excludeAll
                  "
                >
                  All District
                </router-link>
                <button
                  v-for="district in allDistricts"
                  :key="district._id"
                  class="nav-link dropdown-item small"
                  @click="
                    goTo({
                      name: route.name,
                      query: { district: district.name.split(' ').join('_') },
                    })
                  "
                >
                  {{ district.name }}
                </button>
              </div>
            </li>
            <li
              v-else
              :key="route.name"
              class="nav-item justify-content-start justify-content-lg-center"
              :class="{ active: isActiveNav(route.name) }"
            >
              <router-link
                class="nav-link stretched-link"
                :to="{ name: route.name }"
              >
                <font-awesome-icon :icon="route.icon" />{{ route.label }}
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </nav>
    <slot />
    <change-password-modal
      :show="showPasswordModal"
      @close="showPasswordModal = false"
    />
  </div>
</template>

<script>
import API from "@/api";
import ChangePasswordModal from "@/modals/ChangePassword";

export default {
  components: {
    ChangePasswordModal,
  },
  data() {
    return {
      allDistricts: [],
      user: null,
      showPasswordModal: false,
      routes: [
        // {
        //   name: "dashboard",
        //   label: "Dashboard",
        //   icon: ["fas", "home"],
        // },
        // {
        //   name: "defects",
        //   label: "Defects",
        //   icon: ["fas", "exclamation-triangle"],
        //   // roleRestricted: ["Supervisor", "Command Center"],
        // },
        {
          name: "analytics",
          label: "Analytics",
          icon: ["fas", "chart-line"],
          type: "dropdown",
        },
        {
          name: "social",
          label: "Social",
          icon: ["fas", "comment-alt"],
          roleRestricted: ["Supervisor"],
        },
        // {
        //   name: "inbox",
        //   label: "Inbox",
        //   icon: ["fas", "inbox"],
        // },
        {
          name: "cases",
          label: "Cases",
          icon: ["fas", "hard-hat"],
          type: "dropdown",
        },
        {
          name: "reports",
          label: "Reports",
          icon: ["fas", "file-invoice"],
          // roleRestricted: ["Supervisor", "Command Center"],
          type: "dropdown",
          dropdownOptions: {
            excludeAll: true,
          },
        },
        {
          name: "dashcam",
          label: "Dashcam",
          icon: ["fas", "video"],
          roleRestricted: ["Command Center"],
          type: "dropdown",
        },
        // {
        //   name: "live",
        //   label: "Live",
        //   icon: ["fas", "car"],
        // },

        // {
        //   name: "inspection",
        //   label: "Inspection",
        //   icon: ["fas", "truck-pickup"],
        //   roleRestricted: ["Supervisor", "Command Center"],
        // },
      ],
    };
  },
  methods: {
    goTo(route) {
      setTimeout(() => {
        if (
          this.$route.name != route.name ||
          this.$route.query.district != route.query.district
        ) {
          this.$router.push(route);
        }
      }, 300);
    },
    isActiveNav(name) {
      return this.$route.name == name;
    },
    logout() {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      this.$router.push({
        name: "auth",
      });
    },
    async getAllDistricts() {
      return await API.get("districts?_sort=name")
        .then((retVal) => {
          this.allDistricts = retVal.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  mounted() {
    this.getAllDistricts();

    let _user = localStorage.getItem("user");

    if (_user) this.user = JSON.parse(_user);
  },
};
</script>
